/**
 * Derives up to two uppercase initials from a full name.
 *
 * Examples:
 *   "Jan Kowalski"   → "JK"
 *   "Anna"           → "AN"
 *   "  María  José " → "MJ"
 *   null / undefined → ""
 *
 * Algorithm: trim → split on whitespace → take first char of each word →
 * join → uppercase → slice to 2 chars.
 *
 * TODO: 7 local copies of this function still exist and should be migrated here:
 *   - src/epics/technicianManagement/pages/technicianList/TechnicianList.tsx
 *   - src/epics/technicianManagement/pages/editTechnician/editTechnician.tsx
 *   - src/epics/serviceManagement/pages/allServiceRequests/AdminServiceRequestsTab.tsx
 *   - src/epics/serviceManagement/pages/viewServiceRequest/SRHistoryTab.tsx
 *   - src/epics/contactManagement/pages/contactRequestList/ContactRequestList.tsx
 *   - src/epics/clientManagement/pages/clientList/ClientList.tsx
 *   - src/shared/layout/mainLayout/UserProfileDropdown.tsx
 */
export function getInitials(name: string | null | undefined): string {
  if (!name) {
    return '';
  }
  return name
    .trim()
    .split(/\s+/)
    .map((n) => n[0] ?? '')
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
